export const ireland = {
  slug: "ireland",
  name: "Ireland",
  flag: "🇮🇪",
  tagline: "Tech Careers Begin Here",
  heroImg: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#1B7F3B",
  students: "50+",
  avgTuition: "€10,000–€22,000/yr",
  avgLiving: "€900–€1,500/mo",
  workPermit: "2 years post-study",
  ieltsReq: "6.0–6.5",
  intakeMonths: ["September", "January"],
  overview:
    "Ireland is Europe’s tech capital with global employers, English-speaking education, and strong graduate visa benefits.",
  whyChoose: [
    { icon: "🎓", title: "Top Universities", desc: "Trinity College Dublin, UCD, UCC and more." },
    { icon: "💻", title: "Tech Hub", desc: "Google, Meta, Apple, Microsoft EU bases located here." },
    { icon: "🌍", title: "English Speaking", desc: "Easy transition for international students." },
    { icon: "📋", title: "2-Year Stay Back", desc: "Master’s graduates can remain for work search." },
    { icon: "💼", title: "High Salaries", desc: "Strong demand in IT, pharma, finance." },
    { icon: "🤝", title: "PR Pathway", desc: "Long-term settlement through employment." },
  ],
  process: [
    { step: "01", title: "Select Programme", desc: "Choose intake and university." },
    { step: "02", title: "Apply", desc: "Submit academics, SOP, IELTS." },
    { step: "03", title: "Visa", desc: "Apply for Irish student visa." },
    { step: "04", title: "Travel", desc: "Accommodation and arrival prep." },
  ],
  universities: [
    "trinity-dublin","ucd","ucc","nuigalway","dcu",
    "ulimerick","maynooth","tudublin"
  ],
  stats: [
    { n: "50+", label: "Students Placed" },
    { n: "€10k", label: "Min Tuition/yr" },
    { n: "95%", label: "Visa Success" },
    { n: "2yr", label: "Post-Study Permit" },
  ],
};